import React from "react";
import { MSGS, EMAIL_PATTERN } from "../../constants";
import { IMeta } from "../../constants/model-interfaces";
import BaseFormControl from "./base-form-control";
import { MandatoryLabel } from "./common";
export default class BSFormControl extends BaseFormControl {
    hint(): JSX.Element {
        const meta = this.props.form;
        const iconName = meta.icons ? Object.keys(meta.icons)[0] : "";
        const icon = this.context?.getIcon(iconName);
        return (
            <div className={`${this.getWrapperClassName()} hint-wrapper`} onClick={(e) => this.handleChange(e)}>
                {icon}
                <p className='hint-text'>{meta.displayName}</p>
            </div>
        );
    }

    label(): JSX.Element {
        const meta = this.props.form;
        return (
            <div className='form-group'>
                <label htmlFor={`label_${this.uuid}`}>{meta.displayName}</label>
                <span>{meta.value}</span>
                {this.showInfo(meta)}
            </div>
        );
    }

    date(): JSX.Element {
        // const meta = this.props.form;
        return this.input("date", {
            min: this.props.form.validation?.min
        });
    }

    month() {
        return this.input("month", {
            min: this.props.form.validation?.min,
            max: this.props.form.validation?.max
        });
    }

    input(type: string, props: any) {
        const meta = this.props.form;
        return (
            <div className='form-group'>
                <label htmlFor={`input_${type}_${this.uuid}`}>
                    {meta.displayName}
                    {this.validation.required && <MandatoryLabel />}
                </label>
                <input
                    type={type}
                    className='form-control'
                    placeholder={meta.displayName}
                    id={`input_${type}_${this.uuid}`}
                    value={this.props?.form?.value}
                    disabled={this.props.form.isDisabled}
                    readOnly={this.props.form.isReadonly}
                    required={this.validation.required}
                    {...props}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.handleValidation.bind(this)}
                />
                {this.showInfo(meta)}
                {this.showValidation(meta)}
            </div>
        );
    }

    text(): JSX.Element {
        return this.input("text", {
            pattern: this.validation.pattern
        });
    }

    password(): JSX.Element {
        return this.input("password", {});
    }

    file() {
        return this.input("file", {});
    }

    hidden() {
        return this.input("hidden", {});
    }

    range() {}
    email() {
        return this.input("email", {
            pattern: this.validation.pattern ? this.validation.pattern : EMAIL_PATTERN
        });
    }

    number() {
        return this.input("number", {
            min: this.props?.form?.validation?.min,
            max: this.props?.form?.validation?.max
        });
    }

    radio(): JSX.Element {
        const meta = this.field.meta;
        return (
            <div className='form-group'>
                <label>{meta.displayName}</label>
                {meta.options
                    ? meta.options.map((option, index) => {
                          return (
                              <div className='form-check' key={index}>
                                  <input
                                      type='radio'
                                      className='form-check-input'
                                      id={"radio" + this.uuid + index}
                                      name={this.field.name}
                                      onChange={this.handleChange.bind(this)}
                                      value={option.value}
                                      checked={option.value === this.props?.form?.value}
                                      disabled={this.props.form.isDisabled}
                                  />
                                  <label htmlFor={"radio" + this.uuid + index} className='form-check-label'>
                                      {option.label}
                                  </label>
                              </div>
                          );
                      })
                    : ""}
                {this.showInfo(meta)}
            </div>
        );
    }

    radioButton() {
        const meta = this.field.meta;
        return (
            <div className='form-group'>
                <label>{meta.displayName}</label>
                {meta.options
                    ? meta.options.map((option, index) => {
                          return (
                              <div className='form-check' key={index}>
                                  <button className='form-check-input' id={"radio" + this.uuid + index} name={this.field.name}>
                                      {option.label}
                                  </button>
                              </div>
                          );
                      })
                    : ""}
                {this.showInfo(meta)}
            </div>
        );
    }

    checkbox(): JSX.Element {
        const meta = this.props.form;
        return (
            <div className='form-group'>
                <label>{meta.displayName}</label>
                {meta.options &&
                    meta.options.map((option, index) => {
                        return (
                            <div className='form-check' key={index}>
                                <input
                                    type='checkbox'
                                    className='form-check-input'
                                    disabled={this.props.form.isDisabled}
                                    id={"checkbox" + this.uuid + index}
                                    name={this.field.name}
                                    checked={option.value === this.props.form.value}
                                    onChange={(e) => {
                                        this.handleChange(e, e.target.checked ? option.value : "");
                                    }}
                                    value={option.value}
                                />
                                <label htmlFor={"checkbox" + this.uuid + index} className='form-check-label'>
                                    {option.label}
                                </label>
                            </div>
                        );
                    })}
                {this.showInfo(meta)}
            </div>
        );
    }

    select(): JSX.Element {
        const meta = this.props.form;
        const value = this.props.form?.value ? this.props.form.value + "" : "";
        return (
            <div className='form-group'>
                <label htmlFor={"select" + this.uuid}>
                    {meta.displayName}
                    {this.validation.required && <MandatoryLabel />}
                </label>
                <select
                    className='form-control'
                    id={"select" + this.uuid}
                    disabled={this.props.form.isDisabled}
                    required={this.validation.required}
                    value={value}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.handleValidation.bind(this)}
                >
                    <option disabled value=''>
                        Choose...
                    </option>
                    {meta.options
                        ? meta.options.map((option: any) => {
                              return (
                                  <option key={option.value} value={option.value}>
                                      {option.label}
                                  </option>
                              );
                          })
                        : ""}
                </select>
                {this.showInfo(meta)}
                {this.showValidation(meta)}
            </div>
        );
    }

    multiselect() {
        const meta = this.props.form;
        const value = this.props.form?.value ? this.props.form.value + "" : "";
        return (
            <div className='form-group'>
                <label htmlFor={"select" + this.uuid}>
                    {meta.displayName}
                    {this.validation.required && <MandatoryLabel />}
                </label>
                <select
                    className='form-control'
                    id={"select" + this.uuid}
                    multiple
                    disabled={this.props.form.isDisabled}
                    required={this.validation.required}
                    value={value}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.handleValidation.bind(this)}
                >
                    <option disabled value=''>
                        Choose...
                    </option>
                    {meta.options
                        ? meta.options.map((option: any) => {
                              return (
                                  <option key={option.value} value={option.value}>
                                      {option.label}
                                  </option>
                              );
                          })
                        : ""}
                </select>
                {this.showInfo(meta)}
                {this.showValidation(meta)}
            </div>
        );
    }

    button(): JSX.Element {
        throw new Error("Method not implemented.");
    }

    search() {
        return this.input("search", {});
    }

    phone() {
        return this.input("tel", {});
    }

    showValidation(meta: IMeta) {
        return this.state.error.hasError && <div className='invalid-feedback'>{this.state.error.errorMsg}</div>;
    }

    showInfo(meta: IMeta) {
        const infoDetail =
            // eslint-disable-next-line camelcase
            meta?.validation?.info_detail || meta?.validation?.infoDetail;
        return (
            infoDetail?.infoMsg && (
                <small id={"note" + this.uuid} className='form-text text-muted'>
                    {infoDetail.infoMsg}
                </small>
            )
        );
    }
}
